import getLang from 'I18n/utils/getLang';
import { useQuery } from 'data-fetching-client';
import { GET_SUGGESTION_SECTIONS_QUERY as PUBLIC_GET_SUGGESTION_SECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { GET_SUGGESTION_SECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { useAppContext } from '../context/AppContext';
export function useGetSuggestionSections() {
  const appContext = useAppContext();
  const {
    data,
    loading,
    error
  } = useQuery(appContext === 'app' ? GET_SUGGESTION_SECTIONS_QUERY : PUBLIC_GET_SUGGESTION_SECTIONS_QUERY, {
    variables: {
      maximumSections: 10,
      language: getLang(),
      minimumSectionCardCount: 4,
      maximumSectionCardCount: 10
    }
  });
  return {
    data: data === null || data === void 0 ? void 0 : data.result.sections,
    loading,
    error
  };
}